import script from "./announcement-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./announcement-modal.vue?vue&type=script&setup=true&lang=ts"

import "./announcement-modal.vue?vue&type=style&index=0&id=536c5ef8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536c5ef8"]])

export default __exports__